/**
 * Composant Top Products Card
 * Affiche les produits les plus vendus avec tendances
 */

import {
  Component,
  OnInit,
  input,
  output,
  inject,
  DestroyRef,
  ChangeDetectorRef,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  AnalyticsService,
  TopProduct,
  PeriodType,
  TrendType,
} from '../../../../services/analytics.service';
import { LogService } from '../../../../../services/log.service';

@Component({
  selector: 'app-top-products-card',
  imports: [CommonModule],
  templateUrl: './top-products-card.component.html',
  styleUrls: ['./top-products-card.component.css'],
})
export class TopProductsCardComponent implements OnInit {
  private log = inject(LogService);
  private analyticsService = inject(AnalyticsService);
  private destroyRef = inject(DestroyRef);
  private cdr = inject(ChangeDetectorRef);

  readonly period = input<PeriodType>('today');
  readonly limit = input<number>(5);
  readonly productClicked = output<string>();

  products: TopProduct[] = [];
  isLoading = true;
  error: string | null = null;

  ngOnInit(): void {
    this.loadProducts();
  }

  loadProducts(): void {
    this.isLoading = true;
    this.error = null;

    this.analyticsService
      .getTopProducts(this.period(), this.limit())
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (data) => {
          this.products = data;
          this.isLoading = false;
          this.cdr.markForCheck();
        },
        error: (err) => {
          this.log.error('Erreur chargement top produits:', err);
          this.error = 'Impossible de charger les produits';
          this.isLoading = false;
          this.cdr.markForCheck();
        },
      });
  }

  onProductClick(productId: string): void {
    this.productClicked.emit(productId);
  }

  getTrendIcon(trend: TrendType): string {
    switch (trend) {
      case 'up':
        return '↗️';
      case 'down':
        return '↘️';
      default:
        return '→';
    }
  }

  getTrendClass(trend: TrendType): string {
    switch (trend) {
      case 'up':
        return 'text-emerald-600';
      case 'down':
        return 'text-red-500';
      default:
        return 'text-gray-500';
    }
  }

  formatCurrency(value: number): string {
    return new Intl.NumberFormat('fr-FR', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(value);
  }

  getBarWidth(percentage: number): string {
    return `${Math.min(percentage, 100)}%`;
  }
}
